module.exports = __webpack_public_path__ + "img/img_letter_axkt@2x.560e8ace.png";